var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.058 48.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f19149;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator",
    "data-name": "Text Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.029,
    cy: 24.029,
    r: 24.029
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.756,34.573a26.239,26.239,0,0,1-1.994-1.881.751.751,0,0,1-.1-.087L16.06,26a5.61,5.61,0,0,1-1.642-3.964V20.024a27.615,27.615,0,0,1,.08-2.862A2.591,2.591,0,0,1,17.159,14.5a27.666,27.666,0,0,1,2.865-.083H22.04A5.614,5.614,0,0,1,26,16.059l6.6,6.6c.015.015.031.031.045.047a27.179,27.179,0,0,1,1.922,2.036,2.593,2.593,0,0,1,0,3.765,27.81,27.81,0,0,1-1.966,2.082c-.015.016-.031.032-.047.046l0,0L30.611,32.6a.875.875,0,0,1-.08.081,26.906,26.906,0,0,1-2,1.891,2.594,2.594,0,0,1-3.764,0ZM17.34,16.091a1.077,1.077,0,0,0-1.249,1.251c-.067.6-.072,1.485-.072,2.683V22.04a4.005,4.005,0,0,0,1.173,2.831l6.518,6.518a.974.974,0,0,1,.1.084c.848.848,1.48,1.473,1.95,1.848s.721.46.881.46.414-.087.881-.462,1.1-1,1.948-1.843a.755.755,0,0,1,.059-.054l1.937-1.957.04-.039.006,0c.824-.823,1.438-1.446,1.806-1.906a1.638,1.638,0,0,0,.462-.881c0-.16-.086-.414-.46-.881s-1-1.1-1.848-1.95c-.013-.013-.026-.026-.039-.041L24.868,17.2a4,4,0,0,0-2.832-1.174H20.024a25.915,25.915,0,0,0-2.684.063Zm1.1,3.925a1.588,1.588,0,1,1,.462,1.126,1.587,1.587,0,0,1-.462-1.126Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPost);
export default __webpack_public_path__ + "static/media/adPost.955f293b395a69fd557bb3c45878a127.svg";
export { ForwardRef as ReactComponent };